import { Theme as RadixTheme } from '@radix-ui/themes'

export const DexTheme = ({
  children,
  theme,
}: {
  children: React.ReactNode
  theme: 'light' | 'dark'
}) => {
  return (
    <RadixTheme accentColor="orange" grayColor="sand" appearance={theme}>
      {children}
    </RadixTheme>
  )
}
